import { render, staticRenderFns } from "./SmsSettings.vue?vue&type=template&id=4c145909&scoped=true&"
import script from "./SmsSettings.vue?vue&type=script&lang=js&"
export * from "./SmsSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmsSettings.vue?vue&type=style&index=0&id=4c145909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c145909",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c145909')) {
      api.createRecord('4c145909', component.options)
    } else {
      api.reload('4c145909', component.options)
    }
    module.hot.accept("./SmsSettings.vue?vue&type=template&id=4c145909&scoped=true&", function () {
      api.rerender('4c145909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SmsSettings/SmsSettings.vue"
export default component.exports